var map = {
	"./de_DE.json": [
		89107,
		107
	],
	"./en-PS.json": [
		85248,
		867
	],
	"./en-US.json": [
		64962,
		962
	],
	"./fr_FR.json": [
		30465,
		465
	],
	"./ja_JA.json": [
		45387,
		387
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 42825;
module.exports = webpackAsyncContext;